// extracted by mini-css-extract-plugin
module.exports = {"filters":"OnSaleOrRentList_filters__Jz_gT","search":"OnSaleOrRentList_search__3yz23","pagination":"OnSaleOrRentList_pagination__2QJK8","empty":"OnSaleOrRentList_empty__3f1K1"};